import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { PropTypes as MobxPropTypes } from 'mobx-react';
import { observer } from 'mobx-react';

@observer
class GridItemMenu extends Component {
    /**
     * @method resetMenuVisibility
     * @description callback for mouseleave event to hide the item menu
     */
    resetMenuVisibility = () => {
        this.props.cellState.setMenuVisible(false);
    }

    render() {
        const {
            cellState,
            menu
        } = this.props;
        const addButtonMenuStyle = cellState.getAddButtonMenuStyle();
        return (
            <div
                style={addButtonMenuStyle}
                onMouseLeave={() => { this.resetMenuVisibility() }}
                className="tile-dropdown"
            >
                {menu}
            </div>
        );
    }
}

GridItemMenu.propTypes = {
    cellState: MobxPropTypes.observableObject,
    menu: PropTypes.element
};

export default GridItemMenu;



// WEBPACK FOOTER //
// ./ui/share/components/controls/GridLayout/Izenda.GridItemMenu.jsx